export const bithumHref = 'https://en.bithumb.com/trade/order/WOM_KRW';
export const gateIoHref = 'https://www.gate.io/trade/WOM_ETH';
export const kuCoinHref = 'https://trade.kucoin.com/spot/WOM-USDT';
export const mexcHref = 'https://www.mexc.com/exchange/WOM_USDT';
